module.exports = __webpack_public_path__ + "a8ae4ca91deeac953a0f400a65ca698a.png";